import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-dialog-ok-cancel',
  templateUrl: './dialog-ok-cancel.component.html',
  styleUrls: ['./dialog-ok-cancel.component.css']
})
export class DialogOkCancelComponent implements OnInit {
  data: any;
  constructor(public dialogRef: MatDialogRef<DialogOkCancelComponent>,
    @Inject(MAT_DIALOG_DATA) public params: any
  ) {
    this.data = params;
  }
  close(){
    this.dialogRef.close();
  }
  ngOnInit() {
  }

}
